import { TimeSlot } from "@/types";
import { useEffect, useState } from "react";

const SCHEDULE: Record<number, TimeSlot> = {
  0: { open: "10:45", close: "21:00" }, // Sunday
  1: { open: "10:45", close: "21:00" }, // Monday
  2: { open: "10:45", close: "21:00" }, // Tuesday
  3: { open: "10:45", close: "21:00" }, // Wednesday
  4: { open: "10:45", close: "21:00" }, // Thursday
  5: { open: "10:45", close: "21:00" }, // Friday
  6: { open: "10:45", close: "22:00" }, // Saturday
};

const toMinutes = (time: string) => {
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
};

const formatTime = (time: string) => {
  const [h, m] = time.split(":").map(Number);
  const hour12 = h % 12 || 12;
  const period = h >= 12 ? "PM" : "AM";
  return `${hour12}:${m.toString().padStart(2, "0")} ${period}`;
};

export function useRestaurantStatus(restaurant: any) {
  const [isForceClosed, setIsForceClosed] = useState(false);
  const [isTimeClosed, setIsTimeClosed] = useState(false);
  const [todayTiming, setTodayTiming] = useState<TimeSlot | null>(null);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      const today = now.getDay();
      const currentMinutes = now.getHours() * 60 + now.getMinutes();

      const schedule = SCHEDULE[today];
      if (!schedule) {
        setIsTimeClosed(true);
        return;
      }

      const openMinutes = toMinutes(schedule.open);
      const closeMinutes = toMinutes(schedule.close);
      const isOvernight = closeMinutes < openMinutes;

      const isOpen = isOvernight
        ? currentMinutes >= openMinutes || currentMinutes < closeMinutes
        : currentMinutes >= openMinutes && currentMinutes < closeMinutes;

      setTodayTiming(schedule);
      setIsTimeClosed(!isOpen);
    };

    checkTime();
    const interval = setInterval(checkTime, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setIsForceClosed(restaurant?.isClosed === true);
  }, [restaurant]);

  const isClosed = isForceClosed || isTimeClosed;

  const message = isForceClosed
    ? restaurant?.closureReason ||
      "The restaurant is temporarily closed. Please come back later."
    : isTimeClosed && todayTiming
      ? `Orders can only be placed between ${formatTime(
          todayTiming.open,
        )} and ${formatTime(todayTiming.close)}. Please come back during our opening hours. Thank you!`
      : null;

  return {
    isForceClosed,
    isTimeClosed,
    isClosed,
    todayTiming,
    message,
  };
}
